/* TG premium PDP: delivery dates.
 * Europe/London clock; dispatch cut-off Mon–Fri; weekends and the configured UK bank
 * holidays skipped. Ticks every second. Drives:
 *   [data-tg-dbar]     compact banner under the price
 *   [data-tg-delivery] full module in the policy drawer (countdown, timeline, services)
 *   [data-tg-bar-arr]  arrival line in the sticky bar
 * Config and wording: #tg-config (snippets/tg-config.liquid, from the
 * "TG product page" theme settings). Money uses shop.money_format.
 * Listens for 'tg:variant' (from tg-pdp.js) to switch Standard between Free and paid.
 */
(function () {
  if (window.tgDeliveryLoaded) return;
  window.tgDeliveryLoaded = true;

  var p2 = function (n) { return String(n).padStart(2, '0'); };
  // London wall clock for an instant, as numbers (DST-safe: Intl does the offset)
  var LONDON = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  function wall(ms) {
    var o = {};
    LONDON.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month - 1, d: +o.day, h: +o.hour % 24, mi: +o.minute, s: +o.second };
  }
  // Calendar days are UTC-midnight Date objects, so adding days never crosses a DST edge.
  function day(y, m, d) { return new Date(Date.UTC(y, m, d)); }
  // The real instant (ms) of a London wall time on a given calendar day, across BST/GMT.
  function londonInstant(dayDate, hour) {
    var guess = Date.UTC(dayDate.getUTCFullYear(), dayDate.getUTCMonth(), dayDate.getUTCDate(), hour, 0, 0);
    for (var i = 0; i < 2; i++) {
      var w = wall(guess);
      var asUtc = Date.UTC(w.y, w.m, w.d, w.h, w.mi, w.s);
      guess += Date.UTC(dayDate.getUTCFullYear(), dayDate.getUTCMonth(), dayDate.getUTCDate(), hour, 0, 0) - asUtc;
    }
    return guess;
  }
  function ymd(d) { return d.getUTCFullYear() + '-' + p2(d.getUTCMonth() + 1) + '-' + p2(d.getUTCDate()); }

  var cfg = null, S = {}, price = 0, svc = 'std', locale = 'en-GB', available = true;
  function fmt(d) { return d.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); }
  function money(pence) {
    var f = window.tgFormatMoney;
    var out = f ? f(pence) : String((pence / 100).toFixed(2));
    return out.replace(/[.,]00(?=\D*$)/, ''); // like money_without_trailing_zeros
  }
  function fill(t, map) { return String(t || '').replace(/\{(\w+)\}/g, function (a, k) { return k in map ? map[k] : a; }); }
  function num(v, d) { return v === null || v === undefined || v === '' || isNaN(Number(v)) ? d : Number(v); }

  function readConfig() {
    var node = document.getElementById('tg-config');
    var c = {};
    try { c = node ? JSON.parse(node.textContent) : {}; } catch (e) {}
    S = c.strings || {};
    locale = /^[a-z]{2}-[A-Z]{2}$/.test(c.locale || '') ? c.locale : 'en-GB';
    cfg = {
      cutoffHour: num(c.cutoffHour, 15),
      freeThreshold: num(c.freeThreshold, 5000),
      stdPrice: num(c.stdPrice, 0),
      expPrice: num(c.expPrice, 0),
      returnDays: num(c.returnDays, 30),
      lead: num(c.dispatchLeadDays, 0),
      stdMin: num(c.stdMinDays, 1),
      stdMax: num(c.stdMaxDays, 3),
      expDays: num(c.expDays, 1),
      holidays: Array.isArray(c.holidays) ? c.holidays : []
    };
    price = num(c.variantPrice, 0);
    available = c.available !== false;
  }
  function isWork(d) { return d.getUTCDay() % 6 !== 0 && cfg.holidays.indexOf(ymd(d)) === -1; }
  function addWork(d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isWork(x)) n--; } return x; }
  function set(root, sel, txt) { var n = root.querySelector(sel); if (n && n.textContent !== txt) n.textContent = txt; }
  function html(root, sel, h) { var n = root.querySelector(sel); if (n && n.innerHTML !== h) n.innerHTML = h; }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function compute() {
    var nowMs = Date.now(), w = wall(nowMs);
    var today0 = day(w.y, w.m, w.d);
    var sameDay = isWork(today0) && w.h < cfg.cutoffHour;
    var base = sameDay ? today0 : addWork(today0, 1);
    var disp = cfg.lead > 0 ? addWork(base, cfg.lead) : base;
    var today = sameDay && cfg.lead === 0;
    var a = addWork(disp, cfg.stdMin), b = addWork(disp, cfg.stdMax), e = addWork(disp, cfg.expDays);
    var ms = Math.max(0, londonInstant(disp, cfg.cutoffHour) - nowMs);
    return {
      today: today, disp: disp, a: a, b: b, longWait: ms > 24 * 36e5,
      std: fmt(a) + ' – ' + fmt(b), exp: fmt(e),
      H: Math.floor(ms / 36e5), M: Math.floor(ms % 36e5 / 6e4), S: Math.floor(ms % 6e4 / 1e3)
    };
  }

  function render() {
    if (!cfg) return;
    var r = compute();
    var free = price >= cfg.freeThreshold;
    var dates = svc === 'std' ? r.std : r.exp;
    // Special Delivery is always paid; the free threshold only applies to Standard
    var arrival = svc === 'exp'
      ? fill(S.dlExp, { price: money(cfg.expPrice), dates: r.exp })
      : fill(free ? S.dlFree : S.dlPaid, { price: money(cfg.stdPrice), dates: r.std });
    var when = r.today ? S.today : fmt(r.disp);
    var units = S.units || ['', '', ''];

    document.querySelectorAll('[data-tg-dbar]').forEach(function (el) {
      el.classList.toggle('is-oos', !available);
      if (!available) {
        set(el, '[data-tg-bn-t]', S.oosTitle || '');
        set(el, '[data-tg-bn-c]', S.oosText || '');
        return;
      }
      set(el, '[data-tg-bn-t]', arrival);
      html(el, '[data-tg-bn-c]', r.longWait
        ? fill(esc(S.dispatchDay), { date: '<em>' + esc(fmt(r.disp)) + '</em>' })
        : fill(esc(S.orderWithin), { time: '<em>' + r.H + 'h ' + p2(r.M) + 'm ' + p2(r.S) + 's</em>', when: esc(when) }));
    });
    document.querySelectorAll('[data-tg-bar-arr]').forEach(function (el) {
      var t = available ? arrival : (S.oosBar || '');
      if (el.textContent !== t) el.textContent = t;
    });

    document.querySelectorAll('[data-tg-delivery]').forEach(function (el) {
      if (!available) {
        html(el, '[data-tg-cd]', '');
        html(el, '[data-tg-dl-t]', '<b>' + esc(S.oosTitle || '') + '</b><small>' + esc(S.oosText || '') + '</small>');
      } else {
        html(el, '[data-tg-cd]', r.longWait
          ? '<span class="tg-cd-day">' + esc(fmt(r.disp).split(' ')[0]) + '<small>' + esc(S.dayUnit || '') + '</small></span>'
          : '<span>' + p2(r.H) + '<small>' + esc(units[0]) + '</small></span><span>' + p2(r.M) +
            '<small>' + esc(units[1]) + '</small></span><span>' + p2(r.S) + '<small>' + esc(units[2]) + '</small></span>');
        var head = r.today ? S.sameDay : fill(S.dispatchOn, { date: fmt(r.disp) });
        var get = fill(S.getIt, { dates: dates }) + (svc === 'exp' ? ' ' + S.withExpress : '');
        html(el, '[data-tg-dl-t]', '<b>' + esc(head) + '</b><small>' + esc(get) + '</small>');
      }
      var cap = S.today ? S.today.charAt(0).toUpperCase() + S.today.slice(1) : '';
      set(el, '[data-tg-t1]', cap);
      set(el, '[data-tg-t2]', r.today ? cap : fmt(r.disp));
      set(el, '[data-tg-t3]', svc === 'std' ? r.std : r.exp); // same format as the banner
      set(el, '[data-tg-d-std]', fill(S.arrives, { dates: r.std }) + ' · ' + fill(S.workingDays, { min: cfg.stdMin, max: cfg.stdMax }));
      set(el, '[data-tg-d-exp]', fill(S.arrives, { dates: r.exp }));
      var pStd = el.querySelector('[data-tg-p-std]');
      if (pStd) {
        var t = free ? S.free : money(cfg.stdPrice);
        if (pStd.textContent !== t) pStd.textContent = t;
        pStd.classList.toggle('is-free', free);
      }
      el.querySelectorAll('.tg-sv-r').forEach(function (row) {
        var inp = row.querySelector('[data-tg-svc]');
        if (inp) inp.checked = inp.value === svc;
        row.classList.toggle('is-on', !!(inp && inp.value === svc));
      });
    });

    // returns timeline: estimated delivery (earliest Standard) → last day to return
    var end = new Date(r.a.getTime()); end.setUTCDate(end.getUTCDate() + cfg.returnDays);
    document.querySelectorAll('[data-tg-rt-start]').forEach(function (n) { var t = (S.retEst ? S.retEst + ' ' : '') + fmt(r.a); if (n.textContent !== t) n.textContent = t; });
    document.querySelectorAll('[data-tg-rt-end]').forEach(function (n) { var t = fmt(end); if (n.textContent !== t) n.textContent = t; });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-tg-svc]')) { svc = e.target.value; render(); }
  });
  document.addEventListener('tg:variant', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && typeof v.price === 'number') price = v.price;
    if (e.detail && typeof e.detail.available === 'boolean') available = e.detail.available;
    render();
  });
  function init() { readConfig(); render(); }
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  var timer = setInterval(function () {
    if (!document.querySelector('[data-tg-dbar],[data-tg-delivery],[data-tg-bar-arr]')) return;
    if (!document.hidden) render();
  }, 1000);
  window.addEventListener('pagehide', function () { clearInterval(timer); });
})();
